import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.action';
import { useDispatch } from 'react-redux';

export default function SearchRambo({ updateRambo=null, defaultValue=null, required=false, id="rambo_id", reset=false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [q, setQ] = useState("");
    const [rambo, setRambo] = useState(defaultValue);
    const [rambos, setRambos] = useState([]);
    const [isTouched, setIsTouched] = useState(false);

    const searchRambos = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }rambos/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setRambos(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchRambos();
    }, [searchRambos, location]);

    useEffect(() => {
        if(reset)
            setIsTouched(false);
    }, [reset]);

    useEffect(() => {
        if(q.length >= 2){
            searchRambos(q);
        }
    }, [searchRambos, q]);
    
    useEffect(() => {
        setQ("");
        if(updateRambo && rambo){
            updateRambo(rambo);
        }
    }, [updateRambo, rambo]);

    useEffect(() => {
        setRambo(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor={ id } className='form-control'>{ rambo ? "Rambo " + rambo.code : 'Rechercher rambo' }</label>
                <input type='text' ref={ autocompleteInputRef } id={ id } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} placeholder={ rambo ? "Rambo " + rambo.code : 'Rechercher rambo' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { rambos.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setRambo(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> Rambo { item.code }</li>
                        )
                    }) }
                    { rambos.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { isTouched && required && rambo === null && <div className='form-error'>Veuillez sélectionner le rambo.</div> }
        </>
    )
}
